import React from 'react';
import Layout from 'components/layout';
import HeadData from 'components/head-data';
import AgentPage from 'components/agent-search/agent-profile';
import { AGENTS_ROUTE } from 'components/dynamic-page/route-matchers';
import { ThemeNames } from 'types/themes';
import { getThemeOverrideFromRequest } from 'utils/themes';
import { themes } from 'themes';
import { GTM_AGENT_PROFILE_VIEW, GTM_AGENT_PROFILE_RETURN_TEXT_CLICK, GTM_CLICK_AGENT_PROFILE_COPY_EMAIL, GTM_CLICK_AGENT_PROFILE_COPY_PHONE, GTM_AGENT_PROFILE_SERVICE_BUTTON_CLICK, GTM_AGENT_JOIN_EXP_BUTTON_CLICK } from 'constants/events';
import { trackEvent } from 'utils/google-tag-manager';
import { onSocialMediaLinkClick } from 'pages/agents-search/[...dynamic]';

import type { GetServerSidePropsContext } from 'next';

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const agentInfoFromQuery = context.query.dynamic && context.query.dynamic[0];
  const themeName = getThemeOverrideFromRequest(context.req);

  const getHeading = () => {
    const fullName = agentInfoFromQuery?.split('_')[0];
    const agentName = fullName?.replace('-', ' ');

    const theme = themes[themeName];
    if (theme) {
      return {
        title: `${agentName} ${theme.title}`,
        metaDescription: theme.metaDescription,
      };
    }

    return {
      title: `${agentName} - eXp Commercial Brokerage`,
      metaDescription: '',
    };
  };

  if (!themeName || themeName !== ThemeNames.EXP_COMMERCIAL) {
    return {
      redirect: {
        permanent: true,
        destination: '/404',
      },
    };
  }

  return {
    props: {
      routeName: AGENTS_ROUTE,
      props: {
        headTags: getHeading(),
      },
    },
  };
}

interface Props {
  routeName: string;
  props: {
    headTags: {
      title: string;
      metaDescription: string;
    };
  };
}

export default function DynamicAgentPage({ props }: Props) {
  const { headTags } = props;

  const eventTrackers = {
    onPageView: () => trackEvent(GTM_AGENT_PROFILE_VIEW),
    onGoBack: () => trackEvent(GTM_AGENT_PROFILE_RETURN_TEXT_CLICK),
    onSocialMediaLinkClick: onSocialMediaLinkClick,
    onCopyEmailClick: () => trackEvent(GTM_CLICK_AGENT_PROFILE_COPY_EMAIL),
    onCopyPhoneClick: () => trackEvent(GTM_CLICK_AGENT_PROFILE_COPY_PHONE),
    onExploreServicesClick: () => trackEvent(GTM_AGENT_PROFILE_SERVICE_BUTTON_CLICK),
    onJoinExpClick: () => trackEvent(GTM_AGENT_JOIN_EXP_BUTTON_CLICK),
  };

  return (
    <Layout>
      {headTags && <HeadData data={{ title: headTags.title, metaDescription: headTags.metaDescription }} />}
      <AgentPage eventTrackers={eventTrackers}/>
    </Layout>
  );
}
